import { camelize } from '@utils/string'

const read = require.context('./endpoints', true, /\.js$/)
const injectingEndpoints = {}

read.keys().forEach((key) => {
  const endpointData = read(key).default
  const endpointName = camelize(key.replace(/^.*[\\/]/, '').replace('.js', ''))

  injectingEndpoints[endpointName] = endpointData
})

export default injectingEndpoints
